export class ModalBackdrop {
  private static readonly MAIN_SELECTOR = "main"
  private static readonly BACKDROP_SELECTOR = ".modal-backdrop"
  private static readonly MODAL_SHOWN_EVENT = "shown.bs.modal"

  public static initialize = (): void => {
    document.addEventListener(ModalBackdrop.MODAL_SHOWN_EVENT, ModalBackdrop.moveBackdropsIntoMain)
  }

  private static moveBackdropsIntoMain = (): void => {
    // We need to make sure that modal backdrop is always in the main element, otherwise it will stay on PJAX load
    const main = document.querySelector(ModalBackdrop.MAIN_SELECTOR)
    if (!main) return

    const orphanedBackdrops = document.querySelectorAll(`body > ${ModalBackdrop.BACKDROP_SELECTOR}`)
    for (const backdrop of orphanedBackdrops) {
      main.appendChild(backdrop)
    }
  }
}
